import React from 'react';
import './Footer.css';
import { FiMail, FiPhone, FiMapPin, FiChevronUp, FiArrowRight } from 'react-icons/fi';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import YourLogoWhite from '../../Assets/logos.png'; // IMPORTANT: Path to a WHITE version of your logo

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-masterpiece">
      <div className="footer-background-gradient"></div>
      <div className="footer-shape-divider">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31.74,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill-footer"></path>
        </svg>
      </div>

      <div className="footer-content-area container">
        <div className="footer-grid-masterpiece">
          {/* Column 1: Brand & CTA */}
          <div className="footer-column-brand" data-aos="fade-up" data-aos-delay="100">
            <a href="#philosophy" className="footer-logo-link-masterpiece" onClick={scrollToTop}>
              <img src={YourLogoWhite} alt="Adhvik and Adhrit Consultants Services" className="footer-logo-image-masterpiece" />
            </a>
            <h3 className="footer-cta-headline">Ready to Elevate Your Enterprise?</h3>
            <p className="footer-cta-subtext">Let's architect your success story. Connect with our experts today.</p>
            <a href="#contact" className="footer-cta-button">
              Get Started <FiArrowRight className="footer-cta-icon"/>
            </a>
          </div>

          {/* Column 2: Navigation Links */}
          <div className="footer-column-nav" data-aos="fade-up" data-aos-delay="200">
            <h4 className="footer-column-title-masterpiece">Navigate</h4>
            <ul className="footer-nav-list">
          
              <li><a href="/about"><span>About Us</span></a></li>
              <li><a href="/whyus"><span>Why Choose Us</span></a></li>
                  <li><a href="/contact"><span>Contact</span></a></li>
              {/* <li><a href="#services"><span>Services</span></a></li> */}
              {/* <li><a href="#insights"><span>Insights</span></a></li> */}
            </ul>
          </div>

          {/* Column 3: Contact Details */}
          <div className="footer-column-contact" data-aos="fade-up" data-aos-delay="300">
            <h4 className="footer-column-title-masterpiece">Connect</h4>
            <ul className="footer-contact-list">
              <li>
                <FiMail />
                <a href="mailto:abhinav.sen@adhvikandadhrit.com">abhinav.sen@adhvikandadhrit.com</a>
              </li>
              <li>
                <FiPhone />
                <a href="tel:+918209327724">+91 8209327724</a>
              </li>
              <li>
                <FiPhone />
                <a href="tel:+918560809963">+91 8560809963</a>
              </li>
              <li>
                <FiMapPin />
                <span>C-2 FF, Shop No. 17,Jagatpura
                  Jaipur, Rajasthan – 302017</span>
              </li>
            </ul>
            <div className="footer-social-masterpiece">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom-masterpiece">
        <div className="container footer-bottom-content-masterpiece">
           <p>© {currentYear} Adhvik and Adhrit Consultants Services</p>
          <p style={{display:'none'}}>© {currentYear}<a href='https://dheersoftwaresolutions.com/'> Dheer Software Solutions </a></p>
          {/* <button className="scroll-top-masterpiece" onClick={scrollToTop} aria-label="Scroll to top"> */}
            {/* <FiChevronUp />
          </button> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;